<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <strong>Γενικά στοιχεία</strong>
        </CCardHeader>
        <CCardBody class="position-relative">
          <CForm>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Πελάτης
              </CCol>
              <CCol sm="9">
                <multiselect
                  v-model="client"
                  id="client"
                  :options="clients"
                  label="label"
                  track-by="value"
                  @input="selectedClient"
                >
                </multiselect>
              </CCol>
            </div>
            <CInput
              horizontal
              type="text"
              label="Όνομα Πελάτη"
              id="company_name"
              placeholder="Όνομα Πελάτη"
              addLabelClasses="requiredLabel"
              v-model="company_name"
            >
            </CInput>
            <CInput
              horizontal
              type="text"
              label="Όνομα Πελάτη (Αγγλικά)"
              id="company_name_en"
              placeholder="Όνομα Πελάτη (Αγγλικά)"
              addLabelClasses="requiredLabel"
              v-model="company_name_en"
            >
            </CInput>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Υπηρεσία
              </CCol>
              <CCol sm="9">
                <multiselect
                  v-model="service"
                  id="service"
                  :options="services"
                  label="label"
                  @select="changedService"
                  track-by="value"
                >
                </multiselect>
              </CCol>
            </div>
            <CInput
              horizontal
              type="text"
              label="Υπηρεσία (Αγγλικά)"
              id="service_en"
              placeholder="Υπηρεσία (Αγγλικά)"
              v-model="service_en"
            />
            <CInput
              horizontal
              type="text"
              label="Πεδίο για Logo"
              id="certification_title_gr"
              placeholder="Πεδίο για Logo"
              v-model="certification_title_gr"
            />
            <CInput
              horizontal
              type="text"
              label="Πεδίο για Logo (Αγγλικά)"
              id="certification_title_en"
              placeholder="Πεδίο για Logo (Αγγλικά)"
              v-model="certification_title_en"
            />
            <CInput
              horizontal
              type="text"
              label="Πεδίο Πιστοποίησης"
              id="certification_field"
              placeholder="Πεδίο Πιστοποίησης"
              v-model="certification_field"
            >
            </CInput>
            <CInput
              horizontal
              type="text"
              label="Πεδίο Πιστοποίησης (Αγγλικά)"
              id="certification_field_en"
              placeholder="Πεδίο Πιστοποίησης (Αγγλικά)"
              v-model="certification_field_en"
            >
            </CInput>
            <CInput
              label="Ημερομηνία Έκδοσης"
              type="date"
              v-model="certification_date"
              addLabelClasses="requiredLabel"
              horizontal
              @change="calculateDate"
            />
            <CInput
              label="Ημερομηνία Επαναπιστοποίησης"
              type="date"
              v-model="recertification_date"
              horizontal
            />
            <CInput
              label="Ημερομηνία Τελευταίας Τροποποίησης"
              type="date"
              v-model="modification_date"
              horizontal
            />
            <CInput
              label="Ημερομηνία Λήξης"
              type="date"
              v-model="expiration_date"
              addLabelClasses="requiredLabel"
              horizontal
            />
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Κατάσταση
              </CCol>
              <CCol sm="9">
                <multiselect
                  v-model="status"
                  id="status"
                  :options="statuses"
                  label="label"
                  track-by="value"
                >
                </multiselect>
              </CCol>
            </div>
            <CInput
              horizontal
              addLabelClasses="requiredLabel"
              type="text"
              label="Αριθμός πιστοποιητικού"
              id="certificate_no"
              placeholder="Αριθμός πιστοποιητικού"
              v-model="certificate_no"
            />
            <CInput
              horizontal
              type="text"
              label="Αριθμός πιστοποιητικού (Αγγλικά)"
              id="certificate_no_en"
              placeholder="Αριθμός πιστοποιητικού (Αγγλικά)"
              v-model="certificate_no_en"
            />
            <CInput
              horizontal
              addLabelClasses="requiredLabel"
              type="text"
              label="Κωδικός"
              id="password"
              placeholder="Κωδικός"
              v-model="password"
            >
              <!--template #append>
                <CButton color="primary" class="zIndex0" @click="generatePassword()">Ανανέωση</CButton>
              </template-->
            </CInput>
            <CButton color="primary" @click="update()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
            <CElementCover
              :opacity="0.8"
              :boundaries="[{ sides: ['top', 'left'], query: '.card-body' }]"
              v-show="uploading"
            />

            <CButton
              color="primary"
              @click="downloadImages('construction')"
              class="download-button"
            >
              Δομικά Logos
            </CButton>
            <CButton
              color="primary"
              @click="downloadImages('iso')"
              class="download-button"
            >
              ISO Logos
            </CButton>
            <CButton
              color="primary"
              @click="renderCertificate"
              class="download-button"
            >
              ISO
            </CButton>
            <CButton
              color="primary"
              @click="renderCertificateNoIAF"
              class="download-button"
            >
              ISO no IAF
            </CButton>
            <CButton
              color="primary"
              @click="renderCertificateDomika"
              class="download-button"
            >
              Δομικά 1+
            </CButton>
            <CButton
              color="primary"
              @click="renderCertificateDomika2"
              class="download-button"
            >
              Δομικά 2+
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { svgTemplate } from "../../svgTemplate.js";
import { Canvg } from "canvg";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

function nullGetter(part, scopeManager) {
  /*
        If the template is {#users}{name}{/} and a value is undefined on the
        name property :

        - part.value will be the string "name"
        - scopeManager.scopePath will be ["users"] (for nested loops, you would have multiple values in this array, for example one could have ["companies", "users"])
        - scopeManager.scopePathItem will be equal to the array [2] if
          this happens for the third user in the array.
        - part.module would be empty in this case, but it could be "loop",
          "rawxml", or or any other module name that you use.
    */

  if (!part.module) {
    // part.value contains the content of the tag, eg "name" in our example
    // By returning '{' and part.value and '}', it will actually do no replacement in reality. You could also return the empty string if you prefered.
    return "";
  }
  if (part.module === "rawxml") {
    return "";
  }
  return "";
}

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}

export default {
  name: "EditCertification",
  components: {
    Multiselect
  },
  props: {
    caption: {
      type: String,
      default: "Edit Certification"
    }
  },
  data: () => {
    return {
      showMessage: false,
      message: "",
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      client: "",
      status: "",
      service: "",
      clients: [],
      statuses: [],
      services: [],
      uploading: false,
      certification_date: new Date().toISOString().substr(0, 10),
      expiration_date: moment(new Date())
        .add(3, "y")
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      certification_field: "",
      certification_field_en: "",
      certification_title_gr: "",
      certification_title_en: "",
      password: "",
      company_name: "",
      company_name_en: "",
      alertIsShown: false,
      modification_date: "",
      recertification_date: "",
      isActive: true,
      certificate_no: "",
      service_en: "",
      certificate_no_en: ""
    };
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (!newVal && this.saved) {
        this.$emit("closed-alert");
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      // this.$router.replace({path: '/clients'})
    },
    changedService(service) {
      this.certification_field = service.certification_field;
    },
    generatePassword() {
      const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < 8; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      this.password = result;
    },
    update() {
      let self = this;
      let client_id = null;
      if (self.client) {
        client_id = self.client.value;
      }

      let service_id = null;
      if (self.service) {
        service_id = self.service.value;
      }

      let status_id = null;
      if (self.status) {
        status_id = self.status.value;
      }
      self.uploading = true;
      axios
        .post(
          "/api/certifications/" +
            self.$route.params.id +
            "?token=" +
            localStorage.getItem("api_token"),
          {
            _method: "PUT",
            certification_date: self.certification_date,
            expiration_date: self.expiration_date,
            client: client_id,
            certification_field: self.certification_field,
            certification_field_en: self.certification_field_en,
            password: self.password,
            status: status_id,
            service: service_id,
            company_name: self.company_name,
            company_name_en: self.company_name_en,
            modification_date: self.modification_date,
            recertification_date: self.recertification_date,
            isActive: self.isActive,
            certificate_no: self.certificate_no,
            certificate_no_en: self.certificate_no_en,
            service_en: self.service_en,
            title_gr: self.certification_title_gr,
            title_en: self.certification_title_en
          }
        )
        .then(function(response) {
          self.message = "Επιτυχής επεξεργασία πιστοποιητικού.";
          self.showAlert();
          self.uploading = false;
        })
        .catch(function(error) {
          self.uploading = false;
          if (error.response.data.message == "The given data was invalid.") {
            self.message = "";
            for (let key in error.response.data.errors) {
              if (error.response.data.errors.hasOwnProperty(key)) {
                self.message += error.response.data.errors[key][0] + "  ";
              }
            }
            self.showAlert();
          } else {
            self.$router.push({ path: "/login" });
          }
        });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.alertIsShown = true;
    },
    selectedClient() {
      this.services = this.client.services.map(item => {
        return {
          value: item.id,
          label: item.name,
          certification_field: item.pivot.certification_field
        };
      });
      this.service = this.services[0];
      this.company_name = this.client.label;
      this.company_name_en = this.client.company_name_en;
      this.certification_field = this.service.certification_field;
    },
    calculateDate() {
      this.expiration_date = moment(this.certification_date)
        .add(3, "y")
        .subtract(1, "days")
        .format("YYYY-MM-DD");
    },

    async downloadPNG_JPEG(svgString, fileName, type = "image/png") {
      // Parse the SVG string into an SVG element
      // const parser = new DOMParser();
      // const svgElement = parser.parseFromString(svgString, "image/svg+xml");

      // Create a canvas element
      const canvas = document.createElement("canvas");

      // Set the width and height of the canvas to the dimensions of the SVG element
      canvas.width = 1122;
      canvas.height = 793;

      // Get the context of the canvas and draw the SVG element on it
      const ctx = canvas.getContext("2d");

      // canvg(canvas, svgString);

      let v = null;

      v = await Canvg.fromString(ctx, svgString);

      v.start();

      // Convert the canvas to a PNG image
      const pngImage = canvas.toDataURL(type);

      const link2 = document.createElement("a");
      link2.href = pngImage;
      link2.download = fileName;

      // Trigger the download
      link2.click();

      window.onbeforeunload = () => {
        v.stop();
      };
    },


    makeTitle(label){
      let isoGR = ""
      let isoEN = ""
      switch (label) {
          case "ISO 9001":
            isoGR = "ΕΛΟΤ EN ISO 9001:2015";
            isoEN = "ELOT EN ISO 9001:2015";
            break;
          case "ISO 14001":
            isoGR = "ΕΛΟΤ EN ISO 14001:2015";
            isoEN = "ELOT EN ISO 14001:2015";
            break;
          case "ISO 45001":
            isoGR = "ΕΛΟΤ ISO 45001:2018";
            isoEN = "ELOT ISO 45001:2018";
            break;
          case "ISO 39001":
            isoGR = "ISO 39001:2012";
            isoEN = "ISO 39001:2012";
            break;
          case "ΔΙΑΦΟΡΑ ΕΡΓΑ":
            isoGR = this.service_en ? this.service_en : "";
            isoEN = this.service_en ? this.service_en : "";
            break;
          case "ISO 3834-":
            if (
              this.certification_title_gr !== null &&
              this.certification_title_gr.length > 0
            ) {
              isoGR = this.certification_title_gr;
            } else if (
              this.service.label !== null &&
              this.service.label.length > 0
            ) {
              isoGR = this.service.label;
            } else {
              isoGR = "";
            }
            if (
              this.certification_title_en !== null &&
              this.certification_title_en.length > 0
            ) {
              isoEN = this.certification_title_en;
            } else if (this.service_en !== null && this.service_en.length > 0) {
              isoEN = this.service_en;
            } else {
              isoEN = "";
            }
            break;
          default:
            isoGR = this.service.label;
            isoEN = this.service.label;
        }

        return {isoGR: isoGR, isoEN: isoEN};
    },

    async downloadImages(service) {
      let titleGR = "";
      let isoGR = "";
      let cerNumberGR = "";

      let titleEN = "";
      let isoEN = "";
      let cerNumberEN = "";

      cerNumberGR = this.certificate_no === null ? "" : this.certificate_no;
      cerNumberEN =
        this.certificate_no_en === null ? "" : this.certificate_no_en;

      const labels = this.makeTitle(this.service.label)

      if (service === "construction") {
        titleGR = "Πιστοποιημένος Ε.Π.Ε.";
        titleEN = "Certified FPC";
      } else {
        titleGR = "Πιστοποιημένο ΣΔ";
        titleEN = "Certified MS";
      }

      if(this.certification_title_gr !== null && this.certification_title_gr.length > 0){
        isoGR = this.certification_title_gr
      }
      else{
        isoGR = labels.isoGR
      }

      if(this.certification_title_en !== null && this.certification_title_en.length > 0){
        isoEN = this.certification_title_en
      }else{
        isoEN = labels.isoEN
      }

      //svg multicolor download GR
      let finalSvg = svgTemplate.replace("$$$title", titleGR);
      finalSvg = finalSvg.replace("$$$ISO", isoGR);
      finalSvg = finalSvg.replace("$$$cer", "Αρ Πιστ. " + cerNumberGR);

      const svgBlob = new Blob([finalSvg], {
        type: "image/svg+xml;charset=utf-8"
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(svgBlob);
      link.download = "bqv_logo_red_gr.svg";
      link.click();
      URL.revokeObjectURL(link.href);

      this.downloadPNG_JPEG(finalSvg, "bqv_logo_red_gr.png");

      setTimeout(
        () => {
          this.downloadPNG_JPEG(finalSvg, "bqv_logo_red_gr.jpeg", "image/jpeg");
        },
        200 // Delay download every 200ms
      );

      // svg black_white download GR

      const svgBlackWhite = finalSvg.replace(
        /fill="#d91f26"/g,
        'fill="#000000"'
      );

      const svgBlobNocolor = new Blob([svgBlackWhite], {
        type: "image/svg+xml;charset=utf-8"
      });

      const link2 = document.createElement("a");
      link2.href = URL.createObjectURL(svgBlobNocolor);
      link2.download = "bqv_logo_black_gr.svg";
      link2.click();
      URL.revokeObjectURL(link2.href);
      // png/jpeg black_white download
      setTimeout(
        () => {
          this.downloadPNG_JPEG(svgBlackWhite, "bqv_logo_black_gr.png");
        },
        200 // Delay download every 200ms
      );

      setTimeout(
        () => {
          this.downloadPNG_JPEG(
            svgBlackWhite,
            "bqv_logo_black_gr.jpeg",
            "image/jpeg"
          );
        },
        400 // Delay download every 200ms
      );

      //svg multicolor download EN
      let finalSvgEN = svgTemplate.replace("$$$title", titleEN);
      finalSvgEN = finalSvgEN.replace("$$$ISO", isoEN);
      finalSvgEN = finalSvgEN.replace(
        "$$$cer",
        "Certificate No. " + cerNumberEN
      );

      const svgBlobEN = new Blob([finalSvgEN], {
        type: "image/svg+xml;charset=utf-8"
      });

      const linkEN = document.createElement("a");
      linkEN.href = URL.createObjectURL(svgBlobEN);
      linkEN.download = "bqv_logo_red_en.svg";
      linkEN.click();
      URL.revokeObjectURL(linkEN.href);

      setTimeout(
        () => {
          this.downloadPNG_JPEG(finalSvgEN, "bqv_logo_red_en.png");
        },
        600 // Delay download every 200ms
      );
      setTimeout(
        () => {
          this.downloadPNG_JPEG(
            finalSvgEN,
            "bqv_logo_red_en.jpeg",
            "image/jpeg"
          );
        },
        800 // Delay download every 200ms
      );

      // svg black_white download EN

      const svgBlackWhiteEN = finalSvgEN.replace(
        /fill="#d91f26"/g,
        'fill="#000000"'
      );

      const svgBlobNocolorEN = new Blob([svgBlackWhiteEN], {
        type: "image/svg+xml;charset=utf-8"
      });

      const link3 = document.createElement("a");
      link3.href = URL.createObjectURL(svgBlobNocolorEN);
      link3.download = "bqv_logo_black_en.svg";
      link3.click();
      URL.revokeObjectURL(link3.href);
      // png/jpeg black_white download EN

      setTimeout(
        () => {
          this.downloadPNG_JPEG(svgBlackWhiteEN, "bqv_logo_black_en.png");
        },
        1000 // Delay download every 200ms
      );
      setTimeout(
        () => {
          this.downloadPNG_JPEG(
            svgBlackWhiteEN,
            "bqv_logo_black_en.jpeg",
            "image/jpeg"
          );
        },
        1200 // Delay download every 200ms
      );
    },

    renderFile(input, data, output) {
      let self = this;
      loadFile(input, function(error, content) {
        if (error) {
          throw error;
        }
        var zip = new PizZip(content);
        var doc = new Docxtemplater(zip, { nullGetter: nullGetter });
        doc.setData(data);
        try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render();
        } catch (error) {
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a properties object containing all suberrors).
          function replaceErrors(key, value) {
            if (value instanceof Error) {
              return Object.getOwnPropertyNames(value).reduce(function(
                error,
                key
              ) {
                error[key] = value[key];
                return error;
              },
              {});
            }
            return value;
          }
          console.log(JSON.stringify({ error: error }, replaceErrors));

          if (error.properties && error.properties.errors instanceof Array) {
            const errorMessages = error.properties.errors
              .map(function(error) {
                return error.properties.explanation;
              })
              .join("\n");
            console.log("errorMessages", errorMessages);
            // errorMessages is a humanly readable message looking like this :
            // 'The tag beginning with "foobar" is unopened'
          }
          throw error;
        }
        var out = doc.getZip().generate({
          type: "blob",
          mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        }); //Output the document using Data-URI
        saveAs(out, output);
      });
    },

    renderCertificate_el() {
      var input = "/files/newDocs/certificate_iso_template_el.docx";

      let isoGR = "";
      switch (this.service.label) {
        case "ISO 9001":
          isoGR = "ΕΛΟΤ EN ISO 9001:2015";
          break;
        case "ISO 14001":
          isoGR = "ΕΛΟΤ EN ISO 14001:2015";
          break;
        case "ISO 45001":
          isoGR = "ΕΛΟΤ EN ISO 45001:2018";
          break;
        case "ISO 39001":
          isoGR = "ISO 39001:2012";
          break;
        default:
          isoGR = this.service.label;
      }

      var data = {
        date: moment().format("DD-MM-YYYY"),
        company_name: this.client.label,
        address: `${this.client.address}, ${this.client.town}, Τ.Κ. ${
          this.client.postcode === null ? "" : this.client.postcode
        }`,
        certificate_field:
          this.certification_field === null ? "" : this.certification_field,
        certificate: this.certificate_no === null ? "" : this.certificate_no,
        date_start: this.certification_date,
        date_modification: this.modification_date === null ? "" : this.modification_date,
        date_end: this.expiration_date,
        iso: isoGR,
        password: this.password
      };
      var output = "certificate_el.docx";
      this.renderFile(input, data, output);
    },

    renderCertificate_en() {
      var input = "/files/newDocs/certificate_iso_template_en.docx";
      let certificate_field_en = "";
      let certificate_en = "";
      if (this.certification_field_en !== null) {
        certificate_field_en = this.certification_field_en;
      } else if (this.certification_field !== null) {
        certificate_field_en = this.certification_field;
      }

      if (this.certificate_no_en !== null) {
        certificate_en = this.certificate_no_en;
      } else if (this.certificate_no !== null) {
        certificate_en = this.certificate_no;
      }

      let isoEN = "";
      switch (this.service.label) {
        case "ISO 9001":
          isoEN = "ELOT EN ISO 9001:2015";
          break;
        case "ISO 14001":
          isoEN = "ELOT EN ISO 14001:2015";
          break;
        case "ISO 45001":
          isoEN = "ELOT EN ISO 45001:2018";
          break;
        case "ISO 39001":
          isoEN = "ISO 39001:2012";
          break;
        default:
          isoEN = this.service.label;
      }

      var data = {
        date: moment().format("DD-MM-YYYY"),
        company_name:
          this.company_name_en === null
            ? this.client.label
            : this.company_name_en,
        address: `${this.client.address}, ${this.client.town}, P.C. ${this.client.postcode}`,
        certificate_field: certificate_field_en,
        certificate: certificate_en,
        date_start: this.certification_date,
        date_modification:
          this.modification_date === null ? "" : this.modification_date,
        date_end: this.expiration_date,
        iso: isoEN,
        password: this.password
      };
      var output = "certificate_en.docx";
      this.renderFile(input, data, output);
    },

    renderCertificateNoIAF_el() {
      var input = "/files/newDocs/certificate_iso_no_iaf_template_el.docx";

      let isoGR = "";
      switch (this.service.label) {
        case "ISO 9001":
          isoGR = "ΕΛΟΤ EN ISO 9001:2015";
          break;
        case "ISO 14001":
          isoGR = "ΕΛΟΤ EN ISO 14001:2015";
          break;
        case "ISO 45001":
          isoGR = "ΕΛΟΤ EN ISO 45001:2018";
          break;
        case "ISO 39001":
          isoGR = "ISO 39001:2012";
          break;
        default:
          isoGR = this.service.label;
      }

      var data = {
        date: moment().format("DD-MM-YYYY"),
        company_name: this.client.label,
        address: `${this.client.address}, ${this.client.town}, Τ.Κ. ${
          this.client.postcode === null ? "" : this.client.postcode
        }`,
        certificate_field:
          this.certification_field === null ? "" : this.certification_field,
        certificate: this.certificate_no === null ? "" : this.certificate_no,
        date_start: this.certification_date,
        date_modification: this.modification_date === null ? "" : this.modification_date,
        date_end: this.expiration_date,
        iso: isoGR,
        password: this.password
      };
      var output = "certificate_no_iaf_el.docx";
      this.renderFile(input, data, output);
    },



    renderCertificateNoIAF_en() {
      var input = "/files/newDocs/certificate_iso_no_iaf_template_en.docx";
      let certificate_field_en = "";
      let certificate_en = "";
      if (this.certification_field_en !== null) {
        certificate_field_en = this.certification_field_en;
      } else if (this.certification_field !== null) {
        certificate_field_en = this.certification_field;
      }

      if (this.certificate_no_en !== null) {
        certificate_en = this.certificate_no_en;
      } else if (this.certificate_no !== null) {
        certificate_en = this.certificate_no;
      }

      let isoEN = "";
      switch (this.service.label) {
        case "ISO 9001":
          isoEN = "ELOT EN ISO 9001:2015";
          break;
        case "ISO 14001":
          isoEN = "ELOT EN ISO 14001:2015";
          break;
        case "ISO 45001":
          isoEN = "ELOT EN ISO 45001:2018";
          break;
        case "ISO 39001":
          isoEN = "ISO 39001:2012";
          break;
        default:
          isoEN = this.service.label;
      }

      var data = {
        date: moment().format("DD-MM-YYYY"),
        company_name:
          this.company_name_en === null
            ? this.client.label
            : this.company_name_en,
        address: `${this.client.address}, ${this.client.town}, P.C. ${this.client.postcode}`,
        certificate_field: certificate_field_en,
        certificate: certificate_en,
        date_start: this.certification_date,
        date_modification:
          this.modification_date === null ? "" : this.modification_date,
        date_end: this.expiration_date,
        iso: isoEN,
        password: this.password
      };
      var output = "certificate_no_iaf_en.docx";
      this.renderFile(input, data, output);
    },

    renderCertificate() {
      this.renderCertificate_el();
      console.log("el downloaded");
      this.renderCertificate_en();
      console.log("en downloaded");
    },

    renderCertificateNoIAF() {
      this.renderCertificateNoIAF_el();
      console.log("el No IAF downloaded");
      this.renderCertificateNoIAF_en();
      console.log("en No IAF downloaded");
    },

    renderCertificate_domika_el() {
      var input = "/files/newDocs/certificate_domika_template_el_1.docx";

      var data = {
        date: moment().format("DD-MM-YYYY"),
        company_name: this.client.label,
        address: `${this.client.address}, ${this.client.town}, Τ.Κ. ${
          this.client.postcode === null ? "" : this.client.postcode
        }`,
        certificate_field:
          this.certification_field === null ? "" : this.certification_field,
        iso: this.certificate_no === null ? "" : this.certificate_no,
        date_start: this.certification_date,
        date_modification:
          this.modification_date === null ? "" : this.modification_date,
        date_end: this.expiration_date,
        date_now: this.certification_date,
        password: this.password
      };
      var output = "certificate_domika_el.docx";
      this.renderFile(input, data, output);
    },
    renderCertificate_domika_en() {
      var input = "/files/newDocs/certificate_domika_template_en_1.docx";

      let certificate_field_en = "";
      let certificate_en = "";
      if (this.certification_field_en !== null) {
        certificate_field_en = this.certification_field_en;
      } else if (this.certification_field !== null) {
        certificate_field_en = this.certification_field;
      }

      if (this.certificate_no_en !== null) {
        certificate_en = this.certificate_no_en;
      } else if (this.certificate_no !== null) {
        certificate_en = this.certificate_no;
      }

      var data = {
        date: moment().format("DD-MM-YYYY"),
        company_name:
          this.company_name_en === null
            ? this.client.label
            : this.company_name_en,
        address: `${this.client.address}, ${this.client.town}, P.C. ${
          this.client.postcode === null ? "" : this.client.postcode
        }`,
        certificate_field: certificate_field_en,
        iso: certificate_en,
        date_start: this.certification_date,
        date_modification:
          this.modification_date === null ? "" : this.modification_date,
        date_end: this.expiration_date,
        date_now: this.certification_date,
        password: this.password
      };
      var output = "certificate_domika_en.docx";
      this.renderFile(input, data, output);
    },

    renderCertificateDomika() {
      this.renderCertificate_domika_el();
      console.log("el downloaded");
      this.renderCertificate_domika_en();
      console.log("en downloaded");
    },

    renderCertificate_domika2_el() {
      var input = "/files/newDocs/certificate_domika_template_el_2.docx";
      var data = this.data;
      var output = "certificate_domika_2_el.docx";
      this.renderFile(input, data, output);
    },

    renderCertificate_domika2_en() {
      var input = "/files/newDocs/certificate_domika_template_en_2.docx";
      var data = this.data;
      var output = "certificate_domika_2_en.docx";
      this.renderFile(input, data, output);
    },

    renderCertificateDomika2() {
      this.renderCertificate_domika2_el();
      console.log("domika 2 el downloaded");
      this.renderCertificate_domika2_en();
      console.log("domika 2 en downloaded");
    }
  },

  mounted: function() {
    let self = this;
    axios
      .get(
        "/api/certifications/" +
          self.$route.params.id +
          "/edit?token=" +
          localStorage.getItem("api_token")
      )
      .then(function(response) {
        self.clients = response.data.clients.map(item => {
          return {
            value: item.id,
            label: item.company,
            services: item.services,
            company_name_en: item.company_en,
            address: item.address,
            town: item.town,
            postcode: item.postcode
          };
        });
        self.client = self.clients.find(
          item => item.value == response.data.certification.client_id
        );
        self.statuses = response.data.statuses.map(item => {
          return {
            value: item.id,
            label: item.name
          };
        });
        self.certification_date = moment(
          response.data.certification.certification_date,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        self.expiration_date = moment(
          response.data.certification.expiration_date,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        self.status = {
          label: response.data.certification.status.name,
          value: response.data.certification.status_id
        };
        self.certification_field =
          response.data.certification.certification_field;
        self.certification_field_en =
          response.data.certification.certification_field_en;
        self.company_name = response.data.certification.company_name;
        self.company_name_en = response.data.certification.company_name_en;
        self.password = response.data.certification.password;
        self.certificate_no = response.data.certification.certificate_no;
        self.certificate_no_en = response.data.certification.certificate_no_en;
        self.service_en = response.data.certification.service_en;
        self.certification_title_gr = response.data.certification.title_gr;
        self.certification_title_en = response.data.certification.title_en;

        if (response.data.certification.modification_date) {
          self.modification_date = moment(
            response.data.certification.modification_date,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
        }

        if (response.data.certification.recertification_date) {
          self.recertification_date = moment(
            response.data.certification.recertification_date,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
        }

        self.service = {
          label: response.data.certification.service.name,
          value: response.data.certification.service_id
        };
        self.services = self.client.services.map(item => {
          return {
            value: item.id,
            label: item.name,
            certification_field: item.pivot.certification_field
          };
        });
      })
      .catch(function(error) {
        console.log(error);
        self.$router.push({ path: "/login" });
      });
  }
};
</script>

<style scoped>
.download-button {
  float: right;
  margin-right: 0.5rem;
}
</style>
